import React from 'react'

import {
  Container,
  ShortInfos,
  Grid,
  Header,
  Title,
} from './styles'
import { PresencialFinanceProps } from './props'
import ShortFinanceCard from '../../../../components/finance/cards/short-finance-card'
import ProductsRanking from '../../../../components/finance/cards/products-ranking'
import SalesChart from '../../../../components/finance/cards/sales-chart'
import { FiltersGroup } from './filters'

const PresencialFinance = ({
  generalStats,
  productsRanking,
  chartOptions,
  presetPeriods,
  onSelectPeriod,
  selectedPeriod,
  selectedPaymentMethod,
  onSelectPaymentMethod,
  paymentMethods,
  onFrom,
  from,
  to,
  onTo,
  onDownload,
  hasCustomPeriod,
  onToggleCustomPeriod,
  onApplyFilter,
  onToggleBarsInList,
  loadingDownload,
}: PresencialFinanceProps) => (
  <Container>
    <Header>
      <Title>
        <h1>Financeiro</h1>
        <div />
        <p>Presencial</p>
      </Title>

      <FiltersGroup
        onFrom={onFrom}
        onTo={onTo}
        from={from}
        to={to}
        selectedPaymentMethod={selectedPaymentMethod}
        paymentMethods={paymentMethods}
        onSelectPaymentMethod={onSelectPaymentMethod}
        presetPeriods={presetPeriods}
        onSelectPeriod={onSelectPeriod}
        selectedPeriod={selectedPeriod}
        hasCustomPeriod={hasCustomPeriod}
        onToggleCustomPeriod={onToggleCustomPeriod}
        onApplyFilter={onApplyFilter}
        onDownload={onDownload}
        loadingDownload={loadingDownload}
      />
    </Header>

    <ShortInfos>
      {
          Array.isArray(generalStats) && generalStats.map((item) => (
            <ShortFinanceCard key={item.code} data={item} />
          ))
        }
    </ShortInfos>

    <Grid>
      <SalesChart data={chartOptions} onToggleBarsInList={onToggleBarsInList} />
      <ProductsRanking data={productsRanking as any ?? []} />
    </Grid>
  </Container>
)

export default PresencialFinance
